export default "__VITE_ASSET__DUjwl79F__"